import { Fragment, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store/store';
import { ToastContainer } from 'react-toastify';
import { ROLES } from './utils/roles';
import './css/style.css';
import Home from '../V2/components/Home';
import Perfil from './components/Perfil';
import LoadingOverlay from './components/secondary/LoadingOverlay';
import AuthBootstrapper from './components/secondary/AuthBootstrapper';
import ProtectedRoute from './components/secondary/ProtectedRoute';
import ProgramarCorreo from './components/ProgramarCorreo';
import MisCorreos from './components/MisCorreos';
import Viajes from './components/Viajes';
import ViajesCompletados from './components/ViajesCompletados';
import Ideas from './components/Ideas';
import IdeasCompletadas from './components/IdeasCompletadas';
import GaleriaFotos from './components/GaleriaFotos';
import Contacto from './components/Contacto';
import Recetas from './components/Recetas';
import CalculadoraForex from './components/CalculadoraForex';
import GanadorAleatorio from './components/GanadorAleatorio';
import SopaDeLetras from './components/SopaDeLetras';
import Ranking from './components/Ranking';
import Navbar from './components/secondary/Navbar';
import GenerarEquipos from './components/GenerarEquipos';
import EstadisticasRecetas from './components/EstadisticasRecetas';

export default function AppV2() {
    const darkMode = useSelector((state: RootState) => state.theme.darkMode);
    const loading = useSelector((state: RootState) => state.loading.loading);

    useEffect(() => {
        if (darkMode) {
            document.body.classList.add("dark");
        } else {
            document.body.classList.remove("dark");
        }
    }, [darkMode]);

    return (
        <Fragment>
            {loading && <LoadingOverlay />}
            <AuthBootstrapper />
            <BrowserRouter>
                <Navbar />
                <div className="contenido-app-v2">
                    <Routes>
                        <Route path="*" element={<Navigate to="/" replace />} />
                        <Route path="/" element={<Home />} />
                        <Route path="/inicio" element={<Home />} />
                        <Route path="/perfil" element={<ProtectedRoute><Perfil /></ProtectedRoute>} />
                        <Route path="/correos" element={<ProgramarCorreo />} />
                        <Route path="/mis-correos" element={<ProtectedRoute><MisCorreos /></ProtectedRoute>} />
                        <Route path="/viajes" element={<ProtectedRoute requiredRole={ROLES.A12_B}><Viajes /></ProtectedRoute>} />
                        <Route path="/viajes-completados" element={<ProtectedRoute requiredRole={ROLES.A12_B}><ViajesCompletados /></ProtectedRoute>} />
                        <Route path="/ideas" element={<ProtectedRoute requiredRole={ROLES.A12_B}><Ideas /></ProtectedRoute>} />
                        <Route path="/ideas-completadas" element={<ProtectedRoute requiredRole={ROLES.A12_B}><IdeasCompletadas /></ProtectedRoute>} />
                        <Route path="/galeria" element={<ProtectedRoute requiredRole={ROLES.A12_B}><GaleriaFotos /></ProtectedRoute>} />
                        <Route path="/contacto" element={<Contacto />} />
                        <Route path="/recetas" element={<ProtectedRoute requiredRole={ROLES.A12_B}><Recetas /></ProtectedRoute>} />
                        <Route path="/calculadora-forex" element={<CalculadoraForex />} />
                        <Route path="/ganador-aleatorio" element={<GanadorAleatorio />} />
                        <Route path="/sopa-de-letras" element={<ProtectedRoute requiredRole={ROLES.A12_B}><SopaDeLetras /></ProtectedRoute>} />
                        <Route path="/ranking" element={<ProtectedRoute requiredRole={ROLES.A12_B}><Ranking /></ProtectedRoute>} />
                        <Route path="/generar-equipos" element={<GenerarEquipos />} />
                        <Route path="/estadisticas-recetas" element={<ProtectedRoute requiredRole={ROLES.A12_B}><EstadisticasRecetas /></ProtectedRoute>} />

                    </Routes>
                </div>
            </BrowserRouter>
            <ToastContainer
                position="top-right"
                autoClose={2500}
                newestOnTop
                theme="light"
            />
        </Fragment>
    );
}
